<template>
  <!-- 💡 Vueのルールに従い、すべてを包む「真の一番外側の枠」を用意しました -->
  <div class="lp-container-root">
    
    <!-- メインコンテンツ -->
    <div class="lp-block-wrapper">
      <div class="lp-block-hero">
        <div class="lp-block-container">
          <div class="lp-block-badge">三島市でタイヤの処分・廃棄をお考えの方へ</div>
          
          <div class="lp-block-main-title">
            不要になったアルミホイール付きタイヤの処分を<br>
            <span class="lp-block-highlight">費用0円</span>でスマートに無人回収
          </div>

          
          <!-- 丸型アイコン画像 -->
          <div class="lp-block-avatar-wrapper">
            <img src="@/assets/avatar.webp" alt="運営責任者" class="lp-block-avatar-img">
          </div>

          <div class="lp-block-brand-presenter">
            produced by (株)勝間田タイヤ
          </div>

          <div class="lp-block-sub-title">
            三島市内でタイヤの廃棄にお困りですか？通常、オートバックスやイエローハットなどの大型カー用品量販店、地元のガソリンスタンド、ディーラー等に持ち込むと、1本あたり数百円のタイヤ処分費用（廃タイヤ処理手数料）がかかります。
            <br><br>
            当サービスでは、アルミホイールが付いていれば、タイヤの溝がなくても、古くても【完全無料】で引き取りいたします。沼津門池にある「指定回収場所」へ直接お持ち込みいただくことで、一切の処分費用をかけずにスマートに廃棄が完了します。
            <br>※鉄（スチール）ホイールやタイヤのみは対象外
            <br><br>
            <span class="lp-block-notice-text">🌟 ご自身のタイヤがアルミホイールかどうか分からない場合も、まずはスマホで写真を撮ってLINEへお送りください！当方ですぐにお調べいたします。</span>
          </div>
        </div>
      </div>

      <div class="lp-block-section">
        <div class="lp-block-container">
          <div class="lp-block-section-title">ご利用の流れ</div>
          
          <div class="lp-block-steps-flow">
            <div class="lp-block-step-item">
              <span class="lp-block-step-num">01</span>
              <div class="lp-block-step-title">LINEで写真を送る</div>
              <div class="lp-block-step-desc">公式LINEを追加し、処分したいタイヤの写真をスマホで送るだけ。</div>
            </div>
            
            <div class="lp-block-step-item">
              <span class="lp-block-step-num">02</span>
              <div class="lp-block-step-title">場所の共有</div>
              <div class="lp-block-step-desc">確認後、折り返し沼津市門池にある「詳しい無人回収場所」をご案内します。</div>
            </div>
            
            <div class="lp-block-step-item">
              <span class="lp-block-step-num">03</span>
              <div class="lp-block-step-title">好きな時間に置いて完了</div>
              <div class="lp-block-step-desc">何時でもお好きなタイミングでお持ち込み可能です。完全無人受付のため、対面の立会いや挨拶も一切不要です。</div>
            </div>
          </div>
        </div>
      </div>

      <div class="lp-block-section-cta">
        <div class="lp-block-container">
          <div class="lp-block-cta-text">近隣のご迷惑にならないよう静かに置いていただければ、24時間いつでも大歓迎です。</div>
          <a :href="lineUrl" target="_blank" class="lp-block-btn-cta">
            LINEで無人回収を申し込む
          </a>
        </div>
      </div>

      <!-- フッター -->
      <div class="lp-block-footer">
        <div class="lp-block-container">
          <div class="lp-block-footer-img-wrapper">
            <img src="@/assets/footer-text.webp" alt="" class="lp-block-footer-img">
          </div>
        </div>
      </div>
    </div>

    <!-- 💡 スマホ用固定フッター（rootの直下に置くことで画面最下部に常時浮かせます） -->
    <div class="lp-block-fixed-footer">
      <a :href="lineUrl" target="_blank" class="lp-block-btn-footer-cta">
        LINEで無料回収を依頼する
      </a>
    </div>

  </div>
</template>


<script>
export default {
  name: 'NumazuKaishuuView',
  data() { return { lineUrl: 'https://lin.ee/sFKSEtZ' } },
  mounted() {
    document.title = '三島市のタイヤ処分・廃棄なら | アルミホイール付きなら費用0円回収 - カツマタの無人回収'
  }
}
</script>



<style scoped>
/* 💡 ルート要素のスタイル：これを入れることでfixedが画面全体に対して正しく効きます */
.lp-container-root { display: block; width: 100%; min-height: 100vh; position: relative; margin: 0; padding: 0; text-align: center; }

.lp-block-wrapper { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important; color: #333333 !important; background-color: #ffffff !important; line-height: 1.7 !important; padding-bottom: 120px !important; position: relative !important; display: block !important; width: 100% !important; min-height: 100vh !important; text-align: center !important; margin: 0 !important; padding-top: 0 !important; }
.lp-block-wrapper div, .lp-block-wrapper a, .lp-block-wrapper img, .lp-block-wrapper span { box-sizing: border-box !important; float: none !important; position: relative !important; height: auto !important; max-height: none !important; min-height: 0 !important; top: auto !important; bottom: auto !important; left: auto !important; right: auto !important; }
.lp-block-container { max-width: 480px !important; margin: 0 auto !important; padding: 0 24px !important; width: 100% !important; display: block !important; }
.lp-block-hero { background-color: #f2f8f6 !important; padding: 60px 0 50px 0 !important; display: block !important; width: 100% !important; }
.lp-block-badge { background-color: #e2f0ec !important; color: #2e7d6b !important; padding: 4px 14px !important; border-radius: 4px !important; font-weight: 600 !important; font-size: 0.8rem !important; display: inline-block !important; margin: 0 auto 20px auto !important; letter-spacing: 0.05em !important; }
.lp-block-main-title { font-size: 1.6rem !important; font-weight: 700 !important; line-height: 1.5 !important; margin: 0 0 20px 0 !important; color: #1a3a34 !important; }
.lp-block-highlight { color: #2e7d6b !important; font-size: 1.9rem !important; font-weight: 800 !important; border-bottom: 3px solid #2e7d6b !important; display: inline-block !important; margin: 0 2px !important; padding-bottom: 2px !important; }
.lp-block-avatar-wrapper { margin: 0 auto 25px auto !important; width: 90px !important; height: 90px !important; display: block !important; }
.lp-block-avatar-img { width: 100% !important; height: 100% !important; object-fit: cover !important; border-radius: 50% !important; border: 3px solid #ffffff !important; box-shadow: 0 4px 12px rgba(46, 125, 107, 0.1) !important; display: block !important; }
.lp-block-sub-title { font-size: 0.9rem !important; margin: 0 auto !important; color: #4a5c56 !important; display: block !important; text-align: left !important; }

.lp-block-brand-presenter { font-size: 0.95rem !important; font-weight: 700 !important; color: #2e7d6b !important; margin-bottom: 25px !important; font-style: italic; letter-spacing: 0.05em;}
/* 安心テキスト用スタイル */
.lp-block-notice-text { font-weight: 700 !important; color: #2e7d6b !important; display: block !important; background-color: #ffffff !important; padding: 12px !important; border-radius: 6px !important; border: 1px dashed #2e7d6b !important; margin-top: 10px !important; }

.lp-block-section { padding: 50px 0 30px 0 !important; display: block !important; width: 100% !important; }
.lp-block-section-title { font-size: 1.3rem !important; margin: 0 0 30px 0 !important; font-weight: 700 !important; color: #1a3a34 !important; display: block !important; letter-spacing: 0.05em !important; }
.lp-block-steps-flow { display: flex !important; flex-direction: column !important; gap: 20px !important; width: 100% !important; }
.lp-block-step-item { background: #ffffff !important; padding: 24px 20px 24px 60px !important; border-radius: 8px !important; text-align: left !important; border: 1px solid #eef2f1 !important; box-shadow: 0 4px 12px rgba(46, 125, 107, 0.03) !important; display: block !important; width: 100% !important; }
.lp-block-step-num { font-size: 1.3rem !important; font-weight: 700 !important; color: #2e7d6b !important; position: absolute !important; top: 24px !important; left: 20px !important; line-height: 1 !important; display: inline-block !important; }
.lp-block-step-title { margin: 0 0 6px 0 !important; font-size: 1.05rem !important; font-weight: 700 !important; color: #1a3a34 !important; display: block !important; }
.lp-block-step-desc { margin: 0 !important; font-size: 0.88rem !important; color: #666666 !important; display: block !important; line-height: 1.5 !important; }
.lp-block-section-cta { padding: 10px 0 40px 0 !important; display: block !important; width: 100% !important; }
.lp-block-cta-text { font-weight: 600 !important; color: #2e7d6b !important; margin: 0 0 15px 0 !important; font-size: 0.95rem !important; display: block !important; }
.lp-block-btn-cta { display: inline-block !important; background-color: #2e7d6b !important; color: #ffffff !important; padding: 16px 20px !important; font-size: 1.05rem !important; font-weight: 700 !important; border-radius: 6px !important; text-decoration: none !important; box-shadow: 0 4px 12px rgba(46, 125, 107, 0.15) !important; width: 100% !important; letter-spacing: 0.03em !important; }
.lp-block-footer { background-color: #fafbfc !important; padding: 35px 0 !important; border-top: 1px solid #edf1f0 !important; display: block !important; width: 100% !important; }
.lp-block-footer-img-wrapper { max-width: 360px !important; margin: 0 auto !important; width: 100% !important; }
.lp-block-footer-img { width: 100% !important; height: auto !important; display: block !important; opacity: 0.8 !important; }

/* 💡 最前面かつスマホ画面の最下部に『常に固定』する指定を徹底 */
.lp-block-fixed-footer { position: fixed !important; bottom: 0 !important; left: 0 !important; width: 100% !important; background-color: #ffffff !important; padding: 14px 20px !important; box-shadow: 0 -4px 16px rgba(0,0,0,0.1) !important; z-index: 99999 !important; display: block !important; box-sizing: border-box !important; height: auto !important; }
.lp-block-btn-footer-cta { display: block !important; background-color: #2e7d6b !important; color: #ffffff !important; text-align: center !important; padding: 14px 0 !important; font-weight: 700 !important; font-size: 1.05rem !important; border-radius: 6px !important; text-decoration: none !important; width: 100% !important; box-sizing: border-box !important; box-shadow: 0 4px 12px rgba(46, 125, 107, 0.2) !important; }

@media (min-width: 769px) { .lp-block-fixed-footer { display: none !important; } }
</style>
